

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ServiceChargeRule_ManagedObject

class ServiceChargeRule_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: businessAreaName
    set businessAreaName(value:string) {
        this.setValueForKey(value, 'businessAreaName');
    }
    get businessAreaName():string {
        return this.valueForKey('businessAreaName');
    }
    set businessAreaNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'businessAreaName');
    }
    get businessAreaNamePrimitiveValue():string {
        return this.primitiveValueForKey('businessAreaName');
    }

    // Property: fromPax
    set fromPax(value:number) {
        this.setValueForKey(value, 'fromPax');
    }
    get fromPax():number {
        return this.valueForKey('fromPax');
    }
    set fromPaxPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'fromPax');
    }
    get fromPaxPrimitiveValue():number {
        return this.primitiveValueForKey('fromPax');
    }

    // Property: locationCategoryName
    set locationCategoryName(value:string) {
        this.setValueForKey(value, 'locationCategoryName');
    }
    get locationCategoryName():string {
        return this.valueForKey('locationCategoryName');
    }
    set locationCategoryNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationCategoryName');
    }
    get locationCategoryNamePrimitiveValue():string {
        return this.primitiveValueForKey('locationCategoryName');
    }

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: toPax
    set toPax(value:number) {
        this.setValueForKey(value, 'toPax');
    }
    get toPax():number {
        return this.valueForKey('toPax');
    }
    set toPaxPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'toPax');
    }
    get toPaxPrimitiveValue():number {
        return this.primitiveValueForKey('toPax');
    }
    // Relationship: appArea
    set appArea(value:AppArea) {
        this.setValueForKey(value, 'appArea');
    }
    get appArea():AppArea {
        return this.valueForKey('appArea') as AppArea;
    }
    // Relationship: businessArea
    set businessArea(value:BusinessArea) {
        this.setValueForKey(value, 'businessArea');
    }
    get businessArea():BusinessArea {
        return this.valueForKey('businessArea') as BusinessArea;
    }
    // Relationship: event
    set event(value:VenueEvent) {
        this.setValueForKey(value, 'event');
    }
    get event():VenueEvent {
        return this.valueForKey('event') as VenueEvent;
    }
    // Relationship: locationCategory
    set locationCategory(value:LocationCategory) {
        this.setValueForKey(value, 'locationCategory');
    }
    get locationCategory():LocationCategory {
        return this.valueForKey('locationCategory') as LocationCategory;
    }

    // Relationship: serviceChargeRuleFormats
    protected _serviceChargeRuleFormats:MIOManagedObjectSet = null;
    get serviceChargeRuleFormats():MIOManagedObjectSet {
        return this.valueForKey('serviceChargeRuleFormats');
    }
    addServiceChargeRuleFormatsObject(value:ServiceChargeRuleFormat) {
        this._addObjectForKey(value, 'serviceChargeRuleFormats');
    }
    removeServiceChargeRuleFormatsObject(value:ServiceChargeRuleFormat) {
        this._removeObjectForKey(value, 'serviceChargeRuleFormats');
    }
}
